export enum SocialButtonStyle {
    Google = 'google',
    Facebook = 'facebook',
    YouGovSSO = 'yougov',
}
